import { createSlice } from '@reduxjs/toolkit';
import { AsyncStatus } from '../../../libs/utils/constants/async-status';
import IHome from '../../../libs/utils/interfaces/home-interface';
import { getTypeOfContentExistsForClientThunk } from './home-thunk';

const initialState: IHome = {
    typeofContentExistAsyncStatus: AsyncStatus.INITIAL,
    typeOfContentExist: {},
};

const homeSlice = createSlice({
    name: 'home',
    initialState,
    reducers: {},
    extraReducers: (builder: any) => {
        builder
            .addCase(
                getTypeOfContentExistsForClientThunk.pending,
                (state: IHome) => {
                    state.typeofContentExistAsyncStatus = AsyncStatus.LOADING;
                }
            )
            .addCase(
                getTypeOfContentExistsForClientThunk.fulfilled,
                (state: IHome, { payload }: any) => {
                    state.typeofContentExistAsyncStatus = AsyncStatus.SUCCESS;
                    state.typeOfContentExist = payload;
                }
            )
            .addCase(
                getTypeOfContentExistsForClientThunk.rejected,
                (state: IHome) => {
                    state.typeofContentExistAsyncStatus = AsyncStatus.FAILURE;
                }
            );
    },
});

export default homeSlice.reducer;
